import { ENVIRONMENTS } from 'constants/common';

/**
 * @type {function}
 * @desc An utility function to do [something]
 * @example
 * import { staticAssetBasePath } from 'utils/staticAssetBasePath';
 * const result = staticAssetBasePath( ...args );
 */
export const staticAssetBasePath = () => {
    if ( ENVIRONMENTS.PRODUCTION === CONFIG.env ) {
        return `/${ PLATFORM_NAME }/assets`;
    } else {
        return '../assets';
    }
};
